import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';

import InviteTenantPage from '@rental-manager/pages/Onboarding/InviteTenantPage/component';
import { saveTenantInvitationInfo } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import { DEFAULT_ERROR, TENANT_INFO_UPDATED } from '@rental-manager/constants/NotificationConstants';
import paths from '@rental-manager/pathsManifest';
import { isHighRiskOTP } from '@common/paymentsUtils/moveInCostsUtil';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { pageFlows } from '../../pageFlows';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { moveInCostsSettings, collectMoveInCosts, leaseId } = state.payments.landlord.onboarding[propertyId];
  const isHighRiskOTPPresent = isHighRiskOTP(moveInCostsSettings);
  const { isHighRiskOtpApproved, userConfig, leasesForProperty, newTermSettings } = state.payments.landlord.property;
  const { isRentGuaranteeEnabled } = userConfig;
  return {
    landlordEmail: state.user.email,
    currentTenantEmail: state.payments.landlord.property.currentTerm.tenantEmail,
    tenantFirstName: newTermSettings.tenantFirstName,
    tenantLastName: newTermSettings.tenantLastName,
    emailAddress: newTermSettings.tenantEmail,
    tenantId: newTermSettings.tenantId,
    editMode: newTermSettings.editMode,
    isHighRiskOTPPresent,
    isHighRiskOtpApproved,
    collectMoveInCosts,
    isRentGuaranteeEnabled,
    selectedLease: leasesForProperty[leaseId],
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: (tenantInvitationInfo, editMode) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() =>
        dispatch(
          saveNewTermSettings({
            tenantFirstName: tenantInvitationInfo.tenantFirstName,
            tenantLastName: tenantInvitationInfo.tenantLastName,
            tenantEmail: tenantInvitationInfo.emailAddress,
            tenantId: tenantInvitationInfo.tenantId,
          }),
        ),
      )
      .then(() => editMode && dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => editMode && dispatch(push(baseUrl + paths.dashboard.setupNewTermPage)))
      .then(() => !editMode && dispatch(push(baseUrl + paths.dashboard.dueDatePage)))
      .then(() => editMode && dispatch(showModalNotification(TENANT_INFO_UPDATED)))
      .catch((err) => {
        logError({ error: err });
        return dispatch(showModalNotification(DEFAULT_ERROR));
      }),
  onBack: (tenantInvitationInfo) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveTenantInvitationInfo({ propertyId, tenantInvitationInfo })))
      .then(() => dispatch(goBack())),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveNewTermSettings({ currentPage: pageFlows.NewTenantConfirmation })))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage))),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (tenantInvitationInfo) => dispatchProps.onSubmit(tenantInvitationInfo, stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(InviteTenantPage);
